import { useEffect, useState,useRef } from "react";
import { Button } from "devextreme-react/button";
import { useNavigate } from "react-router-dom";
import apiUrl from '../../../configs/constant';
import axios from "axios";
import Swal from "sweetalert2";
import { Typography } from "@mui/material";
import { set } from "react-hook-form";

interface WorkOrder {
  id: number;
  qty: number;
  satuan: string;
  proses: string;
  kode:string;
  product:string;
  sku:string;
}
interface Proses {
  id: number;
  proses: string;
  qty: number;
  qty_hasil: number;
  satuan: string;
  tgl_awal: string | null;
  tgl_realisasi: string | null;
  tgl_selesai: string | null;
  urutan: number;
}

const processes = ["Printing", "Potong Kain", "Jahit", "QC"];

export default function ProductionInput() {
      const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    
  const [selectedWO, setSelectedWO] = useState<WorkOrder | null>(null);
  const [selectedProcess, setSelectedProcess] = useState<Proses | null>(null);
  const [listWorkOrders, setListWorkOrders] = useState<WorkOrder[]>([]);
  const [listFiltered, setListFiltered] = useState<WorkOrder[]>([]);
  const [listProses, setListProses] = useState<Proses[]>([]);
  const [historyProses, setHistoryProses] = useState<any[]>([]);
  const [filterValue, setFilterValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null); // 🔹 buat reference
  const idleTimer = useRef<NodeJS.Timeout | null>(null);

   useEffect(() => {
    const resetIdleTimer = () => {
      // reset timer tiap ada aktivitas
      if (idleTimer.current) clearTimeout(idleTimer.current);

      idleTimer.current = setTimeout(() => {
        console.log("Idle 5 menit, fokus ke input...");
        inputRef.current?.focus();
      }, 15 * 1000); // 15 detik
    };

    // pasang event listener
    const events = ["mousemove", "keydown", "click", "touchstart"];
    events.forEach((e) => window.addEventListener(e, resetIdleTimer));

    // jalankan pertama kali
    resetIdleTimer();

    // bersihkan event listener saat unmount
    return () => {
      if (idleTimer.current) clearTimeout(idleTimer.current);
      events.forEach((e) => window.removeEventListener(e, resetIdleTimer));
    };
  }, []);

  const getListWorkOrder = () => {
    const url = apiUrl.apiUrl + '/production/work-order/list-order-plan-17';
    
    axios
      .get(url, {
        params: {},
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        if (response.data.success) {
          const data = response.data.data;          
          setListWorkOrders(data);
          setListFiltered(data);
        } else {
          Swal.fire({
            title: 'Pemberitahuan',
            text: response.data.message,
            icon: 'error'
          });
        }
      })
      .catch(error => {
        Swal.fire({
          title: 'Error',
          text: 'Gagal mengambil data work order',
          icon: 'error'
        });
      });
  };

  const getHistoryProses = (proses:any) => {
    console.log(proses);
    const url = apiUrl.apiUrl + '/production/work-order/history-plan/'+proses.id;
    
    axios
      .get(url, {
        params: {},
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        if (response.data.success) {
          const data = response.data.data;          
          setHistoryProses(data);
        } else {
          Swal.fire({
            title: 'Pemberitahuan',
            text: response.data.message,
            icon: 'error'
          });
        }
      })
      .catch(error => {
        Swal.fire({
          title: 'Error',
          text: 'Gagal mengambil data',
          icon: 'error'
        });
      });
  };

  const getListProses = (workOrderId: number) => {
    const url = `${apiUrl.apiUrl}/production/work-order/list-proses-plan/${workOrderId}`;
    
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        if (response.data.success) {
          const data = response.data.data;
          setListProses(data);
        } else {
          Swal.fire({
            title: 'Pemberitahuan',
            text: response.data.message,
            icon: 'error'
          });
        }
      })
      .catch(error => {
        Swal.fire({
          title: 'Error',
          text: 'Gagal mengambil data proses',
          icon: 'error'
        });
      });
  };

  useEffect(() => {
    getListWorkOrder();
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const renderCard = (
    label: string,
    onClick: () => void,
    selected: boolean,
    info?: any
  ) => (
    <div
      onClick={onClick}
      style={{
        backgroundColor: selected ? "#1976d2" : "#f9f9f9",
        color: selected ? "#fff" : "#333",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        marginBottom: "12px",
        cursor: "pointer",
        transition: "0.2s ease-in-out",
      }}
    >
      <div style={{ fontSize: "18px", fontWeight: "bold" }}>{info.sku}</div>
      {info && (
        <div style={{ marginTop: "8px", fontSize: "14px" }}>
          <div><b>ID:</b> {label}</div>
          <div><b>Product:</b> {info.product}</div>
          <div><b>Qty:</b> {info.qty} {info.satuan || "-"}</div>
        </div>
      )}
    </div>
  );
  const renderProses = (
    label: string,
    onClick: () => void,
    selected: boolean,
    data: any
  ) => {
    let backgroundColor = "#f9f9f9";
    let textColor = "#333";
    if(selected) {
      backgroundColor = "#1976d2";
      textColor = "#fff";
    }else if (data) {
      if (data.tgl_selesai) {
        backgroundColor = "#4CAF50"; // hijau muda
        textColor = "#fff";
      } else if (data.tgl_awal) {
        backgroundColor = "#d35400"; // kuning muda
        textColor = "#fff";
      }
    }
    return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: backgroundColor,
        color: textColor,
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        marginBottom: "12px",
        cursor: "pointer",
        transition: "0.2s ease-in-out",
      }}
    >
      <div style={{ fontSize: "16px", fontWeight: "bold" }}>{label}</div>
      {data && (
        <div style={{ marginTop: "8px", fontSize: "12px", opacity: 0.9 }}>
          {data.tgl_awal && (
        <div><b>Mulai:</b> {new Date(data.tgl_awal).toLocaleDateString('id-ID', {
          day: '2-digit',
          month: '2-digit', 
          year: 'numeric'
        })} {new Date(data.tgl_awal).toLocaleTimeString('id-ID', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        })}</div>
          )}
          {data.tgl_selesai && (
        <div><b>Selesai:</b> {new Date(data.tgl_selesai).toLocaleDateString('id-ID', {
          day: '2-digit',
          month: '2-digit', 
          year: 'numeric'
        })} {new Date(data.tgl_selesai).toLocaleTimeString('id-ID', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        })}</div>
          )}
        </div>
      )}
    </div>
    )
  };

  const handleMulaiProses = () => {
    Swal.fire({
      title: 'Masukkan NIK',
      text: `Masukkan NIK untuk memulai proses ${selectedProcess?.proses}`,
      input: 'text',
      inputPlaceholder: 'Masukkan NIK...',
      showCancelButton: true,
      confirmButtonText: 'Mulai Proses',
      cancelButtonText: 'Batal',
      inputValidator: (value) => {
        if (!value) {
          return 'NIK tidak boleh kosong!';
        }
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const url = `${apiUrl.apiUrl}/production/wo-plan/mulai-proses`;
        axios
          .post(url, {
            pic: result.value,
            wo_plan_id: selectedProcess?.id
          }, {
            headers: { Authorization: `Bearer ${token}` }
          })
          .then(response => {
            if (response.data.success) {
                Swal.fire({
                  title: 'Berhasil!',
                  text: `Proses berhasil dimulai ${selectedProcess?.proses}`,
                  icon: 'success',
                  timer: 1000,
                  showConfirmButton: false
                });
              // Refresh data proses
              if (selectedWO?.id) {
                getListProses(selectedWO.id);
              }
              setSelectedProcess(null);
              setHistoryProses([]);
              inputRef.current?.focus();
            } else {
              Swal.fire({
                title: 'Pemberitahuan',
                text: response.data.message,
                icon: 'error'
              });
            }
          })
          .catch(error => {
            Swal.fire({
              title: 'Error',
              text: 'Gagal memulai proses',
              icon: 'error'
            });
          });
      }
    });
  }

  const handleSelesaiProses = () => {
     Swal.fire({
      title: 'Masukkan NIK',
      text: `Masukkan NIK untuk menyelesaikan proses ${selectedProcess?.proses}`,
      input: 'text',
      inputPlaceholder: 'Masukkan NIK...',
      showCancelButton: true,
      confirmButtonText: 'Scan',
      cancelButtonText: 'Batal',
      inputValidator: (value) => {
        if (!value) {
          return 'ID tidak boleh kosong!';
        }
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        // After ID is scanned, ask for quantity
        Swal.fire({
          title: 'Masukkan Quantity',
          text: `ID: ${result.value}`,
          input: 'number',
          inputPlaceholder: 'Masukkan jumlah qty...',
          showCancelButton: true,
          confirmButtonText: 'Selesai',
          cancelButtonText: 'Batal',
          inputValidator: (value) => {
            if (!value || parseInt(value) <= 0) {
              return 'Quantity harus lebih dari 0!';
            }
          }
        }).then((qtyResult) => {
          if (qtyResult.isConfirmed && qtyResult.value) {
            const url = `${apiUrl.apiUrl}/production/wo-plan/selesai-proses`;
            axios
              .post(url, {
                pic: result.value,
                wo_plan_id: selectedProcess?.id,
                qty: parseFloat(qtyResult.value)
              }, {
                headers: { Authorization: `Bearer ${token}` }
              })
              .then(response => {
                if (response.data.success) {
                  // Refresh data proses
                  if (selectedWO?.id) {
                    getListProses(selectedWO.id);
                  }
                  setSelectedProcess(null);
                  setHistoryProses([]);
                  Swal.fire({
                    title: 'Berhasil!',
                    text: `Proses ${selectedProcess?.proses} berhasil diselesaikan`,
                    icon: 'success',
                    timer: 1000,
                    showConfirmButton: false
                  });
                  // window.open(
                  //   `${apiUrl.baseUrl}/production/work-order/cetak-nota-selesai/${response.data?.data}`,
                  //   'notaWindow',
                  //   'width=400,height=600,top=100,left=100,menubar=no,toolbar=no,location=no,status=no,scrollbars=no,resizable=no'
                  // );
                  inputRef.current?.focus();
                } else {
                  Swal.fire({
                    title: 'Pemberitahuan',
                    text: response.data.message,
                    icon: 'error'
                  });
                }
              })
              .catch(error => {
                Swal.fire({
                  title: 'Error',
                  text: 'Gagal menyelesaikan proses',
                  icon: 'error'
                });
            });
          }
        });
      }
    });
  }

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        background: "#eee",
        padding: "16px",
        gap: "16px",
        flexDirection:'column'
      }}
    >
      <h2 style={{background: "#eee",textAlign:"center"}}>INPUT PRODUKSI 17</h2>
      <div
        style={{
          display: "flex",
          height: "100vh",
          background: "#eee",
          flexDirection:'row'
        }}
      >
<div
        style={{
          flex: 1,
          background: "#fff",
          borderRadius: "12px",
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          height: "90vh", // <- batas tinggi supaya scroll aktif
          boxSizing: "border-box",
        }}
      >
        <h2 style={{ marginBottom: "16px" }}>📦 Work Orders</h2>

        <input
          type="text"
          placeholder="Filter work orders..."
          value={filterValue}
          ref={inputRef}
          onChange={(e) => {
            const filterValue = e.target.value.toLowerCase();
            setFilterValue(e.target.value);
            const filtered = listWorkOrders.filter(wo => 
              wo.id.toString().toLowerCase().includes(filterValue) ||
              wo.proses.toLowerCase().includes(filterValue) || wo.kode.toLowerCase().includes(filterValue) || wo.product.toLowerCase().includes(filterValue) || wo.sku.toLowerCase().includes(filterValue)
            );
            console.log(filtered.length);
            if(filtered.length === 1) {
              setSelectedWO(filtered[0]);
              setSelectedProcess(null);
              setHistoryProses([]);
              getListProses(filtered[0].id);
              setFilterValue("");
              // 🔹 langsung fokus ke input lagi setelah clear
              if (inputRef.current) {
                inputRef.current.focus();
              }
            }else{
              setSelectedWO(null);
              setSelectedProcess(null);
              setHistoryProses([]);
              setListProses([]);
            }
            setListFiltered(filtered);

          }}
          style={{
            width: "100%",
            padding: "12px",
            borderRadius: "8px",
            border: "1px solid #2980b9",
            marginBottom: "16px",
            fontSize: "14px",
          }}
        />

        {/* ScrollView container */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",     // <- scroll aktif di sini
            paddingRight: "6px",   // biar scrollbar tidak nutup isi
          }}
        >
          {listFiltered.map((wo) => (
            <div
              key={wo.id}
              style={{
                marginBottom: "12px",
              }}
            >
              {renderCard(
                wo.id.toString(),
                () => {
                  setSelectedWO(wo);
                  setSelectedProcess(null);
                  setHistoryProses([]);
                  getListProses(wo.id);
                },
                selectedWO?.id === wo.id,
                wo
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Panel Proses */}
      <div
        style={{
          flex: 1,
          background: "#fff",
          borderRadius: "12px",
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          height: "90vh", // biar scroll bisa jalan
          boxSizing: "border-box",
        }}
      >
        <h2 style={{ marginBottom: "16px" }}>⚙️ Proses</h2>
        <div
          style={{
            flex: 1,
            overflowY: "auto",
          }}
        >
          { selectedWO ? listProses.map((proses) => (
              <div key={proses.id} style={{ marginBottom: "12px" }}>
                {renderProses(
                  proses.proses,
                  () => {
                    setSelectedProcess(proses);
                    // panggil fungsi untuk mengambil history proses (pastikan getHistoryProses didefinisikan di file)
                    getHistoryProses(proses);
                  },
                  selectedProcess?.id === proses.id,
                  proses
                )}
              </div>
            )) : (
              <div>
                <div style={{
                  backgroundColor: "#fff3cd",
                  color: "#856404",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  border: "1px solid #ffeaa7",
                  textAlign: "center",
                  fontWeight: "500",
                  fontSize: "14px"
                }}>
                  ⚠️ Pilih Work Order terlebih dahulu.
                </div>
              </div>
            )}
          </div>
        </div>


      {/* Panel Penyelesaian */}
      <div
        style={{
          flex: 1,
          background: "#fff",
          borderRadius: "12px",
          padding: "16px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h2 style={{ marginBottom: "16px" }}>✅ Mulai / Selesai</h2>
        {selectedWO && selectedProcess ? (
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div style={{
                backgroundColor: "#f8f9fa",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #e9ecef",
                marginBottom: "16px"
              }}>
                <Typography variant="h6" style={{ 
                  marginBottom: "4px", 
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#333"
                }}>
                  Work Order : {selectedWO.id}
                </Typography>
                <Typography variant="h6" style={{ 
                  marginBottom: "4px", 
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#333"
                }}>
                  Proses : {selectedProcess.proses}
                </Typography>
                <Typography variant="body2" style={{ 
                  marginBottom: "6px",
                  fontSize: "14px",
                  color: "#666"
                }}>
                  Qty Target : {selectedProcess.qty} {selectedProcess.satuan}
                </Typography>
                <Typography variant="body2" style={{ 
                  marginBottom: "0",
                  fontSize: "14px",
                  color: "#666"
                }}>
                  Qty Hasil : {selectedProcess.qty_hasil || 0} {selectedProcess.satuan}
                </Typography>
              </div>
              <Button
                key={selectedProcess.tgl_awal ? "selesai" : "mulai"}
                text={selectedProcess.tgl_awal ? "Selesai Proses" : "Mulai Proses"}
                type={selectedProcess.tgl_awal ? "warning" : "success"}
                stylingMode="contained"
                style={{
                  height: "48px",
                  fontSize: "16px",
                  color: "#fff",
                  backgroundColor: selectedProcess.tgl_awal ? "#ff9800" : "#4CAF50",
                }}
                onClick={() => {
                  if (selectedProcess.tgl_awal==null && selectedProcess.tgl_selesai == null) {
                    handleMulaiProses();
                  } else {
                    handleSelesaiProses();
                  }
                }}
              />
            </div>
            {(() => {
              const formatDateTime = (val: any) => {
                if (!val) return "-";
                try {
                  const d = new Date(val);
                  return d.toLocaleDateString("id-ID", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  }) + " " + d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", hour12: false });
                } catch {
                  return String(val);
                }
              };

                return (
                <div style={{ marginTop: 16 }}>
                  <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>Riwayat Proses</div>

                  {historyProses.length === 0 ? (
                  <div
                    style={{
                    backgroundColor: "#fff3cd",
                    color: "#856404",
                    padding: "12px 16px",
                    borderRadius: 8,
                    border: "1px solid #ffeaa7",
                    textAlign: "center",
                    fontWeight: 500,
                    fontSize: 14,
                    }}
                  >
                    — Belum ada history untuk proses ini —
                  </div>
                  ) : (
                  <div
                    style={{
                    overflowX: "auto",
                    borderRadius: 8,
                    border: "1px solid #e9ecef",
                    maxWidth: "100%", // jangan melebihi parent
                    }}
                  >
                    <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      tableLayout: "fixed", // pastikan kolom tidak memaksa melebar
                    }}
                    >
                    <thead>
                      <tr>
                      <th style={{ textAlign: "left", padding: "10px 12px", background: "#f5f7fa", borderBottom: "1px solid #e6eef8", fontWeight: 600 }}>ID</th>
                      <th style={{ textAlign: "left", padding: "10px 12px", background: "#f5f7fa", borderBottom: "1px solid #e6eef8", fontWeight: 600 }}>Qty</th>
                      <th style={{ textAlign: "left", padding: "10px 12px", background: "#f5f7fa", borderBottom: "1px solid #e6eef8", fontWeight: 600 }}>PIC</th>
                      <th style={{ textAlign: "left", padding: "10px 12px", background: "#f5f7fa", borderBottom: "1px solid #e6eef8", fontWeight: 600 }}>Tanggal Selesai</th>
                      </tr>
                    </thead>
                    <tbody>
                      {historyProses.map((row: any, idx: number) => (
                      <tr key={row.id ?? idx} style={{ background: idx % 2 === 0 ? "#ffffff" : "#fbfdff" }}>
                        <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", fontWeight: 600, whiteSpace: "normal", overflowWrap: "break-word" }}>{row.id ?? "-"}</td>
                        <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", whiteSpace: "normal", overflowWrap: "break-word" }}>{row.qty ?? "-"}</td>
                        <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", whiteSpace: "normal", overflowWrap: "break-word" }}>{row.pic ?? "-"}</td>
                        <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", whiteSpace: "normal", overflowWrap: "break-word" }}>{formatDateTime(row.tgl_selesai)}</td>
                      </tr>
                      ))}
                    </tbody>
                    </table>
                  </div>
                  )}
                </div>
                );
            })()}
          </div>
        ) : (
          <div>
            <div style={{
              backgroundColor: "#fff3cd",
              color: "#856404",
              padding: "12px 16px",
              borderRadius: "8px",
              border: "1px solid #ffeaa7",
              textAlign: "center",
              fontWeight: "500",
              fontSize: "14px"
            }}>
              ⚠️ Pilih Work Order dan Proses terlebih dahulu.
            </div>
          </div>
        )}
      </div>
      </div>
    </div>
  );
}
